import React from "react";

interface FileAnexoProps {
  cpfUsuario?: string;
  cpfEstagiario?: string;
  cpfResponsavel?: string;
  anexo?: string | number[];
  nomeArquivo?: string;
  onChange: (anexo?: string, nomeArquivo?: string) => void;
}

export const FileAnexo: React.FC<FileAnexoProps> = ({
  cpfUsuario,
  cpfEstagiario,
  cpfResponsavel,
  anexo,
  nomeArquivo,
  onChange,
}) => {
  const podeAnexar = cpfUsuario === cpfEstagiario || cpfUsuario === cpfResponsavel;

  const abrirPDF = (base64: string | number[] | Uint8Array) => {
    let blob: Blob;

    if (typeof base64 === "string") {
      if (base64.startsWith("data:")) {
        window.open(base64, "_blank");
        return;
      }
      const byteCharacters = atob(base64);
      const byteArray = Uint8Array.from(byteCharacters, (c) => c.charCodeAt(0));
      blob = new Blob([byteArray], { type: "application/pdf" });
    } else {
      blob = new Blob([new Uint8Array(base64)], { type: "application/pdf" });
    }

    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      onChange(reader.result as string, file.name);
    };
    reader.readAsDataURL(file);
  };

  const handleRemove = () => {
    onChange(undefined, undefined);
    const input = document.getElementById("anexo-input") as HTMLInputElement;
    if (input) input.value = "";
  };

  return (
    <div>
      {podeAnexar && (
        <div className="mb-3">
          <label htmlFor="anexo-input" className="form-label fw-semibold">
            Anexar justificativa (PDF)
          </label>
          <input id="anexo-input" type="file" accept="application/pdf" className="form-control form-control-sm"
            onChange={handleFileChange}
          />
        </div>
      )}

      {anexo && (
        <div className="alert alert-secondary py-2 d-flex align-items-center justify-content-between">
          <div>
            <strong>Arquivo:</strong>{" "}
            <button type="button" className="btn btn-link btn-sm text-decoration-underline p-0"
              onClick={() => abrirPDF(anexo)}
            >
              {nomeArquivo || "Anexo.pdf"}
            </button>
          </div>
          <button type="button" className="btn btn-outline-danger btn-sm ms-2"
            onClick={handleRemove}
          >
            <i className="bi bi-trash"></i> Remover
          </button>
        </div>
      )}
    </div>
  );
};
